import "./Footer.css";

function Footer() {
  return (
    <footer>
      © 2025 Andres Martinez - Todos los derechos reservados
    </footer>
  );
}

export default Footer;
